const booking = {
  booking: {
    title: 'Finalizar reserva',
    property: 'Propiedad',
    unit: 'Alojamiento',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Huéspedes',
    nightsLabel: 'Noches',
    nightSingular: 'noche',
    nightPlural: 'noches',
    guestSingular: 'huésped',
    guestPlural: 'huéspedes',
    serviceFee: 'Tarifa de servicio',
    taxes: 'Impuestos',
    discount: 'Descuento',
    total: 'Total',
    installments: 'Hasta 12 cuotas en tarjeta',
    staySummary: 'Resumen de la estadía',
    priceBreakdown: 'Detalle del valor',
    guestInfo: 'Información del Huésped',
    guestName: 'Nombre completo',
    guestEmail: 'Correo electrónico',
    guestPhone: 'Teléfono / WhatsApp',
    guestPhoneLabel: 'Teléfono',
    payment: 'Pago',
    paymentDetails: 'Datos del pago',
    payAmount: 'Pagar {{amount}}',
    payNow: 'Pagar con Tarjeta',
    processing: 'Procesando...',
    processingPayment: 'Procesando pago...',
    preparingPayment: 'Preparando pago...',
    continueToPayment: 'Continuar al pago',
    fillAllFields: 'Complete todos los datos del huésped para continuar',
    securePayment: 'Pago seguro vía Stripe',
    secureReservation: 'Reserva segura vía Reserve Connect',
    backToReview: 'Volver y revisar datos',
    backToProperty: 'Volver a la propiedad',
    backToSearch: 'Volver a la búsqueda',
    preparingReservation: 'Preparando su reserva...',
    cannotProceed: 'No se pudo continuar',
    incompleteInfo: 'Información de reserva incompleta.',
    cannotCreateIntent: 'No se pudo crear la intención de reserva.',
    errorCreatingIntent: 'Error al crear intención de reserva.',
    paymentCancelled: 'Pago cancelado por el usuario.',
    paymentError: 'Error al procesar el pago.',
    paymentErrorDefault: 'Ocurrió un error al procesar el pago. Intente nuevamente.',
    bookingStatus: 'Estado de la reserva',
    checkingStatus: 'Verificando estado de la reserva...',
    statusPending: 'Pendiente de confirmación',
    statusConfirmed: 'Confirmada',
    statusCheckin: 'Check-in pendiente',
    statusCheckedIn: 'Check-in realizado',
    statusCheckedOut: 'Check-out realizado',
    statusCancelled: 'Cancelada',
    statusNoShow: 'No se presentó',
    statusCompleted: 'Completada',
    statusProcessing: 'Procesando...',
    hostBookingId: 'ID de reserva',
    hostCommitPendingDesc: 'La propiedad está siendo notificada de su reserva.',
    paymentNotCompleted: 'Pago no completado',
    paymentNotApproved: 'El pago no fue aprobado. Verifique los datos e intente nuevamente.',
    processingTimeout: 'El tiempo de procesamiento expiró. Contacte al soporte.',
    cannotConfirmPayment: 'No se pudo confirmar el pago. Intente nuevamente.',
    paymentSystemUnavailable: 'Sistema de pago temporalmente no disponible.',
    cannotStartPayment: 'No se pudo iniciar el pago.',
    errorStartingPayment: 'Error al iniciar el pago.',
    incompletePaymentInfo: 'Información de pago incompleta.',
    timeExpired: 'Tiempo expirado',
    timeExpiredDesc: 'El tiempo para confirmar esta reserva expiró. Realice una nueva búsqueda.',
    redoSearch: 'Volver a buscar',
    hurry: '¡Apúrese! ',
    reservationExpiresIn: 'La reserva expira en',
    minuteSingular: 'minuto',
    minutePlural: 'minutos',
    secondSingular: 'segundo',
    secondPlural: 'segundos',
    confirmed: '¡Reserva Confirmada!',
    confirmedTitle: 'Reserva confirmada',
    confirmedSuccess: 'Su reserva fue confirmada con éxito.',
    confirmationEmailSent: 'Enviamos los detalles a {{email}}',
    confirmationSent: 'Enviamos la confirmación a su correo electrónico.',
    confirmationCode: 'Código de confirmación',
    reservationDetails: 'Detalles de la reserva',
    totalPaid: 'Total pagado',
    detailsEmailed: 'Detalles enviados por correo',
    backToHome: 'Volver al inicio',
    cancelPolicy: 'Política de Cancelación',
    errorPayment: 'Error al procesar el pago. Intente de nuevo.',
    pageTitle: 'Finalizar reserva - Reserve Connect',
    pageDescription: 'Finalice su reserva en Reserve Connect. Precios reales y disponibilidad confirmada.',
    confirmationPageTitle: 'Reserva confirmada - Reserve Connect',
    confirmationPageDesc: 'Su reserva fue confirmada con éxito en Reserve Connect.',

    // Payment method selection
    choosePaymentMethod: 'Elegir método de pago',
    cardPayment: 'Tarjeta de Crédito',
    cardPaymentDesc: 'Pago seguro vía Stripe',
    pixPayment: 'PIX',
    pixPaymentDesc: 'Pago instantáneo vía Mercado Pago',
    installmentsPayment: 'Cuotas',
    installmentsPaymentDesc: 'Pague en hasta 12 cuotas',
    chooseInstallments: 'Elegir número de cuotas',
    installmentsLabel: 'Cuotas',
    installmentsTotal: 'Total: {{total}}',
    installmentsNoInterest: 'Sin intereses',
    selectInstallments: 'Seleccione el número de cuotas',
    payInstallment: 'Pagar {{count}}x de {{value}}',

    // PIX
    pixInstructions: 'Escanee el código QR con su aplicación bancaria para pagar vía PIX.',
    pixCopyPaste: 'O copie y pegue el código PIX:',
    pixWaitingPayment: 'Esperando pago...',
    pixConfirmed: 'Pago confirmado',
    pixGenerationError: 'Error al generar el código QR PIX. Intente nuevamente.',
    errorStartingPix: 'Error al iniciar pago vía PIX.',
    pixExpiresIn: 'Expira a las {{time}}',
    paymentMethod: 'Método de pago',
    copy: 'Copiar',
    installmentsInfo: 'Hasta 12 cuotas en tarjeta',

    // Add-ons
    addOns: 'Adicionales',
    addOnsSubtitle: 'Personalice su estadía con servicios adicionales',
    addOnsTotal: 'Adicionales',
    addOnsNone: 'Ningún adicional seleccionado',
    addOnsPricePerBooking: 'Por reserva',
    addOnsPricePerNight: 'Por noche',
    addOnsPricePerPerson: 'Por persona',
    addOnsContinue: 'Continuar al pago',
    addOnsSkip: 'Saltar, solo quiero el alojamiento',

    // Cancellation keys
    cancelReservation: 'Cancelar Reserva',
    cancelReservationTitle: 'Cancelar reserva',
    cancelConfirmTitle: '¿Está seguro de que desea cancelar?',
    cancelConfirmDesc: 'El reembolso se calculará según la política de cancelación de la propiedad.',
    cancelRefundPreview: 'Recibirá {{amount}} de reembolso',
    cancelRefundFull: 'Reembolso total',
    cancelRefundPartial50: '50% de reembolso',
    cancelRefundNone: 'Sin reembolso para esta fecha',
    cancelRefundCdc: 'Reembolso total (Art. 49 CDC)',
    cancelProcessing: 'Procesando cancelación...',
    cancelSuccess: 'Reserva cancelada con éxito',
    cancelSuccessDesc: 'Su cancelación ha sido procesada. El reembolso se acreditará en un plazo de 10 días hábiles.',
    cancelError: 'No se pudo cancelar la reserva',
    cancelErrorDesc: 'Intente nuevamente o comuníquese con nuestra Central de Reservas.',
    cancelAlreadyCancelled: 'Esta reserva ya fue cancelada.',
    cancelNotCancellable: 'Esta reserva ya no se puede cancelar.',
    cancelDaysUntilCheckin: 'Faltan {{days}} día(s) para el check-in',
    cancelPolicyApplied: 'Política aplicada: {{policy}}',
    cancelReason: 'Motivo de cancelación (opcional)',
    cancelReasonPlaceholder: 'Describa el motivo de la cancelación...',
    cancelSubmit: 'Confirmar cancelación',
    cancelBack: 'Volver',

    addToCalendar: 'Agregar al Calendario',
    addToCalendarHint: 'Descarga un archivo .ics para Google Calendar, Apple Calendar o Outlook',
  },
};
export default booking;
